import Vue from 'vue'
import maskMixin from './mask-mixin'

const abrMixin = {
  methods: {
    formatAbn (raw) {
      return this.format(raw, '## ### ### ###')
    }
  }
}

export default Vue.util.mergeOptions(maskMixin, abrMixin)
